module.exports = __webpack_public_path__ + "img/2025-2.d2055363.jpg";